import React, { FC, useState } from 'react';
import blogPosts, { tagColors, BlogPost } from './BlogPosts';
import { blog } from 'texts/texts';
import { TextWithStyle } from 'components/TextWithStyle';
import { SEO } from 'components/seo/SEO';
import { breadcrumbJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';
import { PostCard, PostCardGrid, TagFilter } from 'components/postCard/PostCard';

import './Blog.css';

const route = routeManifest.find((r) => r.path === '/blog')!;
const breadcrumbs = breadcrumbJsonLd([
  { name: 'Home', path: '/' },
  { name: 'Blog', path: '/blog' },
]);

export const Blog: FC = () => {
  const [selectedTag, setSelectedTag] = useState<string>('View All');

  return (
    <div className="blog-section">
      <SEO title={route.title} description={route.description} path={route.path} jsonLd={[breadcrumbs]} />
      <div className="blog-content-container">
        <div className="blog-header">
          <h1>
            {blog.title.map((part, index) => (
              <TextWithStyle key={index} text={part.text} style={part.style} />
            ))}
          </h1>
          <p>Sharing our learnings, health insights, and company updates 🌱</p>
          <TagFilter tagColors={tagColors} selected={selectedTag} onSelect={setSelectedTag} />
        </div>
        <PostCardGrid>
          {blogPosts
            .filter((post: BlogPost) => selectedTag === 'View All' || post.tag === selectedTag)
            .map((post: BlogPost) => (
              <PostCard
                key={post.id}
                to={`/blog/${post.id}`}
                image={post.image}
                imageCover={post.photo}
                imagePosition={post.photo ? 'center' : undefined}
                tag={post.tag}
                color={tagColors[post.tag]}
                title={post.title}
                subtitle={post.subtitle}
                readTime={post.readTime}
                date={post.date}
                // blog dates are display strings ("30 Jun 2025"); <time> needs YYYY-MM-DD
                dateTime={new Date(post.date).toLocaleDateString('en-CA')}
              />
            ))}
        </PostCardGrid>
      </div>
    </div>
  );
}
